import _set from 'lodash/set';
import _get from 'lodash/get';
import * as logger from '../logging/logger';

export function registerInteropHandler(path: string, fn: (...args: any[]) => void) {
    logger.log('Debug', `Interop: Registering interop handler ${path}`);

    const namespaces = path.split('.');
    const func: string = namespaces.pop() as string;
    let context: any = window;

    for (let i = 0; i < namespaces.length; i++) {
        if (!context[namespaces[i]]) {
            context[namespaces[i]] = {};
        }

        context = context[namespaces[i]];
    }

    context[func] = fn;
}

export function callInteropHandler(path: string, ...args: any[]) {
    try {
        logger.log('Debug', `Interop: callInteropHandler: ${path}`);

        const namespaces = path.split('.');
        const func: string = namespaces.pop() as string;
        let context: any = window;

        for (let i = 0; i < namespaces.length; i++) {
            context = context[namespaces[i]];
        }

        context[func].apply(context, args);
    } catch (e) {
        logger.log('Error', `Interop: Error calling ${path}`);
    }
}

export function registerChildInteropHandler(iframe: HTMLIFrameElement, path: string, fn: (...args: any[]) => void) {
    /* istanbul ignore else */
    if (iframe.contentWindow) {
        _set(iframe.contentWindow, path, fn);
    }
}

export function callChildInteropHandler(iframe: HTMLIFrameElement | null, path: string, ...args: any[]) {
    /* istanbul ignore else */
    if (iframe && iframe.contentWindow) {
        const fn = _get(iframe.contentWindow, path);
        /* istanbul ignore else */
        if (fn) {
            fn.call(null, ...args);
        }
    }
}
